// Story 011 — single-image activation store. The Filmstrip publishes the
// active imageId here when the user clicks/keyboard-walks. The Viewer
// (Story 012) and Tiles (Story 013) subscribe to render the right image
// + the right BBox crops respectively.
//
// `activeImageId === null` until the first image-list resolution sets it
// to the first image (handled in FilmstripWidget on data arrival).
import { create } from "zustand";

export interface ImageActivationState {
  activeImageId: string | null;
  setActive: (imageId: string | null) => void;
  reset: () => void;
}

export const useImageActivationStore = create<ImageActivationState>(
  (set, get) => ({
    activeImageId: null,
    setActive: (imageId) => {
      // SB6-ANA-TILE-01 AC4 — same-image activation is a no-op so a tile
      // (or List-row) click on the already-active image never re-publishes
      // the id, which would otherwise reload the Viewer + re-fire the
      // Filmstrip scroll-into-view (image-reload flicker / scroll jank).
      if (get().activeImageId === imageId) return;
      set({ activeImageId: imageId });
    },
    reset: () => {
      set({ activeImageId: null });
    },
  }),
);
